import { render, staticRenderFns } from "./commodityAdd.vue?vue&type=template&id=4d88bc0e"
import script from "./commodityAdd.vue?vue&type=script&lang=js"
export * from "./commodityAdd.vue?vue&type=script&lang=js"
import style0 from "./commodityAdd.vue?vue&type=style&index=0&id=4d88bc0e&prod&lang=css"
import style1 from "./commodityAdd.vue?vue&type=style&index=1&id=4d88bc0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports